import { create } from 'zustand';
import type { UnlockedEntry } from '../qr/types';

export type Screen =
  | { kind: 'home' }
  | { kind: 'scanner' }
  | { kind: 'collection' }
  | { kind: 'detail'; entry: UnlockedEntry }
  | { kind: 'ar'; entry: UnlockedEntry };

type Store = {
  screen: Screen;
  go: (screen: Screen) => void;
  back: () => void;
};

export const useNav = create<Store>((set) => ({
  screen: { kind: 'home' },
  go: (screen) => set({ screen }),
  back: () => set({ screen: { kind: 'home' } }),
}));
